var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShipNowHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 40,
    viewBox: "0 0 76 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.303 34.173H72.9658C72.9658 34.173 74.6241 33.0475 74.6241 31.8035C74.6241 30.5714 74.9202 28.6402 73.4396 28.2493C73.4751 26.8868 73.9963 21.7332 70.6086 20.9038C70.3125 20.347 69.0451 17.5984 67.9672 15.2526C66.9722 13.0727 64.7927 11.6628 62.3882 11.6628H53.303",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1713 21.0461L63.2287 16.8994C63.0866 16.5914 62.7786 16.4019 62.447 16.4019H58.0288V22.3256H64.3422C65.0173 22.3256 65.4556 21.6384 65.1713 21.0461Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3987 10.478V1H53.3029V34.1728H15.3987V23.5101",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3987 21.1407V14.0322",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.809 34.1728C30.809 36.7792 28.6887 38.8999 26.0591 38.8999C23.4413 38.8999 21.321 36.7792 21.321 34.1728C21.321 31.5664 23.4413 29.4457 26.0591 29.4457C28.6887 29.4457 30.809 31.5664 30.809 34.1728Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3441 34.1728C66.3441 36.7792 64.2238 38.8999 61.5942 38.8999C58.9765 38.8999 56.8562 36.7792 56.8562 34.1728C56.8562 31.5664 58.9765 29.4457 61.5942 29.4457C64.2238 29.4457 66.3441 31.5664 66.3441 34.1728Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2437 19.9561H4.73804",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2733 10.478H10.6606",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3803 1H10.6606",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29166 1H5.92261",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55334 1H1.18433",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.36902 19.9561H0",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29166 10.478H5.92261",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipNowHover);
export default __webpack_public_path__ + "static/media/ship-now-hover.a9e53408.svg";
export { ForwardRef as ReactComponent };